module.exports = __webpack_public_path__ + "img/logo_gobierno.442c8c5b.png";